export const supplierTaxViewModelStructure = {
    Id: true,
    Name: true,
    Amount: true,
    Priority: true,
    Description: true,
    IdSupplierHotel: true,
    SupplierHotel: {
        Name: true,
    },
    IdSupplierHotelRoomType: true,
    SupplierHotelRoomType: {
        Name: true,
    },
    IdSupplierHotelMealPlan: true,
    SupplierHotelMealPlan: {
        Name: true,
    },
    IdSupplierHotelRatePlan: true,
    SupplierHotelRatePlan: {
        Name: true,
    },
    IdSupplierTaxType: true,
    SupplierTaxType: {
        Name: true,
        Caption: true,
        Key: true,
    },
    IdSupplierTaxCalculationType: true,
    SupplierTaxCalculationType: {
        Name: true,
        Caption: true,
        LocalizedCaption: true,
        Key: true,
    },
    IdSupplierTaxCalculationRuleType: true,
    SupplierTaxCalculationRuleType: {
        Name: true,
        Caption: true,
        LocalizedCaption: true,
        Key: true,
    },
    IdSupplementCalculationType: true,
    SupplementCalculationType: {
        Name: true,
        Caption: true,
        LocalizedCaption: true,
        Key: true,
    },
    IdCurrency: true,
    Currency: {
        Name: true,
    },
    EffectivePerson: true,
    FromAge: true,
    ToAge: true,
    OnlyAdults: true,
    OnlyChildren: true,
    FromDate: true,
    ToDate: true,
    Enabled: true,
};

export const supplierTaxFromViewModelFromSupplierHotel = {
    Id: true,
    Hotel: {
        IdHotelType: true,
        IdHotelCategory: true,
        IdHotelChain: true,
        IdCurrency: true,
        IdCity: true,
        IdProvince: true,
        IdRegion: true,
        IdCountry: true,
        IdTimeZoneUtil: true,
        AdultAge: true,
        BabiesAge: true,
        FirstChildAge: true,
        SecondChildAge: true,
    },
    SupplierTaxes: supplierTaxViewModelStructure,
};
